import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import FNOLBOPWizard from './FNOLBOPWizard';

setComponentMapOverrides(
    {
        FNOLBOPWizard: { component: 'FNOLBOPWizard' },
    },
    {
        FNOLBOPWizard,
    }
);

export { FNOLBOPWizard as default };
